export const NOTIFY = 'NOTIFY'
export const REQUEST_CURRENT_LOCAL_AUTHORITY = 'REQUEST_CURRENT_LOCAL_AUTHORITY'
export const RECEIVE_CURRENT_LOCAL_AUTHORITY = 'RECEIVE_CURRENT_LOCAL_AUTHORITY'
export const REQUEST_CURRENT_LOCAL_AUTHORITY_LOANS = 'REQUEST_CURRENT_LOCAL_AUTHORITY_LOANS'
export const RECEIVE_CURRENT_LOCAL_AUTHORITY_LOANS = 'RECEIVE_CURRENT_LOCAL_AUTHORITY_LOANS'
export const REQUEST_CURRENT_LOCAL_AUTHORITY_SERVICES = 'REQUEST_CURRENT_LOCAL_AUTHORITY_SERVICES'
export const RECEIVE_CURRENT_LOCAL_AUTHORITY_SERVICES = 'RECEIVE_CURRENT_LOCAL_AUTHORITY_SERVICES'
export const REQUEST_CURRENT_USER = 'REQUEST_CURRENT_USER'
export const RECEIVE_CURRENT_USER = 'RECEIVE_CURRENT_USER'
export const REQUEST_LOCAL_AUTHORITIES = 'REQUEST_LOCAL_AUTHORITIES'
export const RECEIVE_LOCAL_AUTHORITIES = 'RECEIVE_LOCAL_AUTHORITIES'
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
export const THROW_ERROR = 'THROW_ERROR'
export const UNNOTIFY = 'UNNOTIFY'
export const UPDATE_CURRENT_LOCAL_AUTHORITY = 'UPDATE_CURRENT_LOCAL_AUTHORITY'
export const UPDATE_LOANS_LOCALLY = 'UPDATE_LOANS_LOCALLY'
export const UPDATE_SERVICES_LOCALLY = 'UPDATE_SERVICES_LOCALLY'
export const REQUEST_LOCAL_AUTHORITIES_CHILDREN = 'REQUEST_LOCAL_AUTHORITIES_CHILDREN'
export const RECEIVE_LOCAL_AUTHORITIES_CHILDREN = 'RECEIVE_LOCAL_AUTHORITIES_CHILDREN'
export const CLEAR_LOCAL_AUTHORITIES_CHILDREN = 'CLEAR_LOCAL_AUTHORITIES_CHILDREN'
export const REQUEST_S3_FILES_LIST = 'REQUEST_S3_FILES_LIST'
export const RECIEVE_S3_FILES_LIST = 'RECIEVE_S3_FILES_LIST'
export const REQUEST_S3_FILES_UPDATE = 'REQUEST_S3_FILES_UPDATE'
export const RECIEVE_S3_FILES_UPDATE = 'RECIEVE_S3_FILES_UPDATE'
export const DELETE_S3_FILE = 'DELETE_S3_FILE'
export const UPLOAD_S3_FILE = 'UPLOAD_S3_FILE'
export const SELECTED_PRIORITIES = 'SELECTED_PRIORITIES'
export const REQUEST_ALL_SCENARIOS = 'REQUEST_ALL_SCENARIOS'
export const RECIEVE_ALL_SCENARIOS = 'RECIEVE_ALL_SCENARIOS'
export const REQUEST_SELECTED_SCENARIOS = 'REQUEST_SELECTED_SCENARIOS'
export const RECIEVE_SELECTED_SCENARIOS = 'RECIEVE_SELECTED_SCENARIOS'
export const REQUEST_SELECTED_SCENARIOS_DATA = 'REQUEST_SELECTED_SCENARIOS_DATA'
export const RECIEVE_SELECTED_SCENARIOS_DATA = 'RECIEVE_SELECTED_SCENARIOS_DATA'
export const REQUEST_UPLOAD_FILE = 'REQUEST_UPLOAD_FILE'
export const RECIEVE_UPLOAD_FILE = 'RECIEVE_UPLOAD_FILE'
export const REQUEST_BUDGET_ANNEXE_DATA = 'REQUEST_BUGET_ANNEXE_DATA'
export const RECIEVE_BUDGET_ANNEXE_DATA = 'RECIEVE_BUDGET_ANNEXE_DATA'
export const LOADER_DATA_VALUE = 'LOADER_DATA_VALUE'
export const RECIEVE_TABLE_DATA = 'RECIEVE_TABLE_DATA'

export const SET_TOTAL_CALLS = 'SET_TOTAL_CALLS';
export const INCREMENT_CALL = 'INCREMENT_CALL';
export const FINISH_CALL = 'FINISH_CALL';
export const SET_ALL_CALLS_FINISHED = 'SET_ALL_CALLS_FINISHED';
export const RESET_ONGOIN_CALL = 'RESET_ONGOIN_CALL';



// WEBPACK FOOTER //
// ./src/actions.ts